export default __webpack_public_path__ + "static/ProValue_2@1200-16db488098e09dc88773ec91b3907378.png";